const colors = {
  "cl-indicator-active": "var(--bs-teal)",
  "cl-indicator-processing": "var(--bs-blue)",
  "cl-indicator-inactive": "var(--bs-red)",

  "cl-status-gray": "var(--bs-gray)",
  "cl-status-blue": "var(--bs-blue)",
  "cl-status-red": "var(--bs-red)",
  "cl-status-orange": "var(--bs-orange)",
  "cl-status-yellow": "var(--bs-yellow)",
  "cl-status-green": "var(--bs-teal)",
};

export default colors;
